import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate, type RouteObject } from 'react-router';
import { PublicLayout } from '@/features/public/PublicLayout';
import { HomePage } from '@/features/public/HomePage';
import { ServicesPage } from '@/features/public/ServicesPage';
import { MyBookingsPage } from '@/features/public/MyBookingsPage';
import { RootPage } from '@/features/public/RootPage';
import { NotFound } from '@/components/StateViews';
import { PageLoader } from '@/components/StateViews';

// Кабинет — отдельный чанк: клиенту не грузится код владельца
const OwnerApp = lazy(() => import('@/features/owner/OwnerApp'));

const routes: RouteObject[] = [
  { path: '/', element: <RootPage /> },
  {
    path: '/s/:slug',
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'my', element: <MyBookingsPage /> },
    ],
  },
  {
    path: '/s/:slug/owner/*',
    element: (
      <Suspense fallback={<PageLoader />}>
        <OwnerApp />
      </Suspense>
    ),
  },
  { path: '/s/:slug/*', element: <Navigate to=".." replace /> },
  { path: '*', element: <NotFound /> },
];

export const router = createBrowserRouter(routes);
